<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>

  <div class="modal-header">
    <h3 class="modal-title font">Datos del consentimiento</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form class="form-search py-3" [formGroup]="formGroup">
      <div class="field">
        <label for="razonSocial">Razón social <span class="oblig">*</span></label>
        <mat-form-field class="custom-mat-form-field" appearance="outline">
          <input matInput id="razonSocial" formControlName="razonSocial" placeholder="Razón social" maxlength="150">
          <mat-error *ngIf="controlHasError('razonSocial', 'required')">Campo obligatorio</mat-error>
          <mat-error *ngIf="controlHasError('razonSocial', 'maxlength')">Máximo 150 caracteres</mat-error>
        </mat-form-field>
      </div>

      <div class="row-fields">
        <div class="field field-20">
          <label for="tipoDocumentoFirmante">Tipo documento firmante <span class="oblig">*</span></label>
          <mat-form-field class="custom-mat-form-field" appearance="outline">
            <mat-select id="tipoDocumentoFirmante" formControlName="tipoDocumentoFirmante" placeholder="Tipo documento">
              <mat-option value="DNI">DNI</mat-option>
              <mat-option value="NIE">NIE</mat-option>
              <mat-option value="CIF">CIF</mat-option>
            </mat-select>
            <mat-error *ngIf="controlHasError('tipoDocumentoFirmante', 'required')">Campo obligatorio</mat-error>
          </mat-form-field>
        </div>

        <div class="field field-33">
          <label for="codigoDocumentoFirmante">Documento firmante <span class="oblig">*</span></label>
          <mat-form-field class="custom-mat-form-field" appearance="outline">
            <input matInput id="codigoDocumentoFirmante" formControlName="codigoDocumentoFirmante" placeholder="Documento firmante" maxlength="15" oninput="this.value = this.value.toUpperCase()">
            <mat-error *ngIf="controlHasError('codigoDocumentoFirmante', 'required')">Campo obligatorio</mat-error>
            <mat-error *ngIf="controlHasError('codigoDocumentoFirmante', 'invalidDocument')">Documento no válido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-50">
          <label for="nombreFirmante">Nombre <span class="oblig">*</span></label>
          <mat-form-field class="custom-mat-form-field" appearance="outline">
            <input matInput id="nombreFirmante" formControlName="nombreFirmante" placeholder="Nombre" maxlength="50">
            <mat-error *ngIf="controlHasError('nombreFirmante', 'required')">Campo obligatorio</mat-error>
            <mat-error *ngIf="controlHasError('nombreFirmante', 'maxlength')">Máximo 50 caracteres</mat-error>
          </mat-form-field>
        </div>

        <div class="field field-50">
          <label for="apellidosFirmante">Apellidos <span class="oblig">*</span></label>
          <mat-form-field class="custom-mat-form-field" appearance="outline">
            <input matInput id="apellidosFirmante" formControlName="apellidosFirmante" placeholder="Apellidos" maxlength="100">
            <mat-error *ngIf="controlHasError('apellidosFirmante', 'required')">Campo obligatorio</mat-error>
            <mat-error *ngIf="controlHasError('apellidosFirmante', 'maxlength')">Máximo 100 caracteres</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer actions">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="cerrar()">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="guardar()">Guardar</button>
    </div>
  </div>
</div>
